<ui-business-card-grid *ngIf="bcData.content" [data]="bcData.content">
</ui-business-card-grid>
